export const environment = {
  production: false,
  apiUrl: 'https://testapi.dmag.io',
  isTest: true,
  isDemo: false,
  enableBugsnag: true,
};
